exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".aVxcmfrPP_mZdoyPCnBAG{height:100%}.aVxcmfrPP_mZdoyPCnBAG p{margin-bottom:0;margin-top:0}.aVxcmfrPP_mZdoyPCnBAG span{font-weight:700}._2OeCicSmeYNbNGli7w1P4G:first-child{margin-top:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"OverallDevelopmentCard": "aVxcmfrPP_mZdoyPCnBAG",
	"OverallDevelopmentCard_subtitle": "_2OeCicSmeYNbNGli7w1P4G"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/UnitReportHFv4/StudentReportView/OverallDevelopmentCard/style.postcss
// module id = 1957
// module chunks = 0